import { render, staticRenderFns } from "./private-button.vue?vue&type=template&id=04724024&scoped=true"
import script from "./private-button.vue?vue&type=script&lang=js"
export * from "./private-button.vue?vue&type=script&lang=js"
import style0 from "./private-button.vue?vue&type=style&index=0&id=04724024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04724024",
  null
  
)

export default component.exports